import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4 justify-center items-center w-screen h-screen">
      <img src="/assets/not_found.png" alt="" width={240} height={304} />
      <div className="flex flex-col gap-2">
        <p className="text-2xl font-medium leading-[150%] tracking-[-0.48px] whitespace-pre-wrap md:whitespace-normal text-center">
          {t("notFoundTitle")}
        </p>
        <p className="text-base font-normal leading-[150%] tracking-[-0.32px] whitespace-pre-wrap md:whitespace-normal text-center">
          {t("notFoundDescription")}
        </p>
      </div>
      <Link
        to="/"
        className="px-4 py-2 bg-white border-black rounded border-[1px] border-[rgba(27,8,45,0.50)] border-solid"
      >
        {t("goBackHome")}
      </Link>
    </div>
  );
}
